import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch, nextTick, onMounted } from 'vue'
import store from '@/store'
import { AloDbFleet } from '@/models/alodb/AloDbFleet'
import MissionDetailConsole from '@/components/mission/MissionDetailConsole.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'FleetDetailConsole',
  props: {
    fleet: null,
    isleft: { type: Boolean },
    uiid: null,
    isVisible: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  fleet: AloDbFleet
  isleft: boolean
  uiid: string
  isVisible: boolean
};



const missions = computed(
  () =>
    props.fleet.param?.missionIds
      ?.map(id => store.myGetters?.missionsById[id])
      ?.filter(m => !!m)
      ?.sort((m, m1) =>
        !props.fleet.activeMissionIds.includes(m.misId!)
          ? 1
          : !props.fleet.activeMissionIds.includes(m1.misId!)
          ? -1
          : props.fleet.activeMissionIds.findIndex(misId => m.misId == misId) -
            props.fleet.activeMissionIds.findIndex(misId => m1.misId == misId),
      ) ?? [],
)

const gliders = computed(() => missions.value.map(m => ({ id: m.misId, libelle: m.gliKey })))

const selectedGliderIdx = ref(0)

const showTabs = ref(true)
onMounted(() => {
  setTimeout(() => {
    showTabs.value = false
    nextTick(() => {
      showTabs.value = true
    })
  }, 100)
})

return { __sfc: true,props, missions, gliders, selectedGliderIdx, showTabs, store, MissionDetailConsole }
}

})